import React from 'react';
import Rule from './Rule';
import RuleDivider from './RuleDivider';

class RuleSet extends React.Component {
  render() {
    const {
      addNewRule,
      addNewRuleSet,
      customGroups,
      last,
      ruleSetIndex,
      ruleSet,
      removeRule,
      updateRule,
      builderRules,
    } = this.props;
    return (
      <div>
        <div className="RuleSet">
          {ruleSet.rules.map((rule, ruleIndex) => (
            <Rule
              customGroups={customGroups}
              addNewRule={addNewRule}
              key={rule.id ? rule.id : rule.key}
              last={ruleIndex === ruleSet.rules.length - 1}
              ruleIndex={ruleIndex}
              ruleSetIndex={ruleSetIndex}
              removeRule={removeRule}
              lastRuleSet={last}
              updateRule={updateRule}
              rule={rule}
              builderRules={builderRules}
            />
          ))}
        </div>
        <RuleDivider addNewRuleSet={addNewRuleSet} last={last} />
      </div>
    );
  }
}

export default RuleSet;
